import { render, staticRenderFns } from "./PlanType.vue?vue&type=template&id=49a15d1a"
import script from "./PlanType.vue?vue&type=script&lang=js"
export * from "./PlanType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports